// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.intents-container { margin: 20px auto; max-width: 100%;  color: #333; }
.intents-container .table-wrapper.profile-table { height: 700px; }

.title {
  text-align: center;
  margin-bottom: 20px;
  color: #4a90e2;
}

.table-responsive {
  overflow-x: auto;
}

.intents-table {
  width: 100%;
  border-collapse: collapse;
  background: #f9f9f9;
}

.intents-table th,
.intents-table td {
  padding: 12px;
  text-align: left;
  border: 1px solid #ddd;
}

.intents-table th {
  background: #4a90e2;
  color: #fff;
}

.intents-table tr:nth-child(even) {
  background: #f2f2f2;
}

.intents-table tr:hover {
  background: #eaeaea;
}

.intents-table ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.intents-table ul li {
  margin: 2px 0;
}

.loading,
.error {
  text-align: center;
  font-size: 18px;
  color: #ff0000;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .intents-table th,
  .intents-table td {
    font-size: 14px;
    padding: 8px;
  }
  .intents-container {
    padding: 0 5px;
}
}
`, "",{"version":3,"sources":["webpack://./src/pages/BotManage/Intent.css"],"names":[],"mappings":"AAAA,qBAAqB,iBAAiB,EAAE,eAAe,GAAG,WAAW,EAAE;AACvE,kDAAkD,aAAa,EAAE;;AAEjE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,eAAe;IACf,YAAY;EACd;EACA;IACE,cAAc;AAClB;AACA","sourcesContent":[".intents-container { margin: 20px auto; max-width: 100%;  color: #333; }\n.intents-container .table-wrapper.profile-table { height: 700px; }\n\n.title {\n  text-align: center;\n  margin-bottom: 20px;\n  color: #4a90e2;\n}\n\n.table-responsive {\n  overflow-x: auto;\n}\n\n.intents-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #f9f9f9;\n}\n\n.intents-table th,\n.intents-table td {\n  padding: 12px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.intents-table th {\n  background: #4a90e2;\n  color: #fff;\n}\n\n.intents-table tr:nth-child(even) {\n  background: #f2f2f2;\n}\n\n.intents-table tr:hover {\n  background: #eaeaea;\n}\n\n.intents-table ul {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n.intents-table ul li {\n  margin: 2px 0;\n}\n\n.loading,\n.error {\n  text-align: center;\n  font-size: 18px;\n  color: #ff0000;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .intents-table th,\n  .intents-table td {\n    font-size: 14px;\n    padding: 8px;\n  }\n  .intents-container {\n    padding: 0 5px;\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
